import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { isFalsy } from 'utility-types';
import { UpdateEscritoRequest } from '@models/escrito/updateEscritoRequest.model';
import { CreateEscritoRequest } from '@models/escrito/createEscritoRequest.model';
import { EscritoDto } from '@models/escrito/escritoDto.model';
import { CreateResponseBase } from '@models/base/createResponseBase.model';
import { EscritoFilter } from '@models/escrito/escritoFilter.model';

@Injectable({
  providedIn: 'root'
})
export class EscritoService {


  constructor(private http: HttpClient) {
  }

  private readonly baseUrl = '/api/Escrito'; // Cambiar por tu URL base

  getAll(): Observable<EscritoDto[]> {
    return this.http.get<EscritoDto[]>(`${this.baseUrl}/GetAll`);
  }

  getById(id: number): Observable<EscritoDto> {
    return this.http.get<EscritoDto>(`${this.baseUrl}/GetById?id=${id}`);
  }

  create(request: CreateEscritoRequest): Observable<EscritoDto> {
    return this.http.post<EscritoDto>(`${this.baseUrl}/Create`, request);
  }

  update(request: UpdateEscritoRequest): Observable<EscritoDto> {
    return this.http.put<EscritoDto>(`${this.baseUrl}/Update`, request);
  }

  delete(id: number): Observable<void> {
    return this.http.delete<void>(`${this.baseUrl}/Delete?id=${id}`);
  }

  deleteLogic(id: number): Observable<void> {
    return this.http.delete<void>(`${this.baseUrl}/DeleteLogic?id=${id}`);
  }

  buscarEscritos(searchTerm: string): Observable<EscritoDto[]> {
    return this.http.get<EscritoDto[]>(`${this.baseUrl}/BuscarEscritos?searchTerm=${searchTerm}`);
  }

  getAllByTipoEscrito(idTipoEscrito: number): Observable<EscritoDto[]> {
    return this.http.get<EscritoDto[]>(`${this.baseUrl}/GetAllByTipoEscrito?idTipoEscrito=${idTipoEscrito}`);
  }

  getAllByFilter(filter: EscritoFilter): Observable<EscritoDto[]> {
    return this.http.post<EscritoDto[]>(`${this.baseUrl}/GetAllByFilter`, filter);
  }

  clone(id: number): Observable<EscritoDto> {
    return this.http.post<EscritoDto>(`${this.baseUrl}/Clone`, { id });
  }

  copyByPlantilla(idPlantilla: number, titulo?: string): Observable<EscritoDto> {
    return this.http.post<EscritoDto>(`${this.baseUrl}/CopyByPlantilla`, {
      idPlantilla,
      titulo
    });
  }

}
